import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { InputNumber } from "primereact/inputnumber";
import { useResponsiveDialog } from "../../../../../Context/ResponsiveDialogContext";
import { getValidationRules, isFieldRequired } from "../PreLoan";

export default function StepDownPayment() {
    const { control, formState: { errors } } = useFormContext();
    const { containerWidth } = useResponsiveDialog();

    const isSmall = containerWidth > 0 && containerWidth < 500;
    const stepKey = 'pagoInicial'; // Definir el stepKey para este componente


    return (
        <div className="p-fluid">
            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Enganche{isFieldRequired('pagoInicial.enganche', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="pagoInicial.enganche" control={control} rules={getValidationRules('pagoInicial.enganche', stepKey)} render={({ field }) => (
                        <InputNumber
                            inputId={field.name}
                            name={field.name}
                            value={field.value}
                            onValueChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            mode="currency"
                            currency="MXN"
                            locale="es-MX"
                            className="w-full TextInput"
                            minFractionDigits={2}
                            maxFractionDigits={2}
                        />
                    )} />
                    {errors.pagoInicial?.enganche && <small className="p-error">{errors.pagoInicial.enganche.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>  Comisión por Apertura {isFieldRequired('pagoInicial.comisionApertura', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="pagoInicial.comisionApertura" control={control} rules={getValidationRules('pagoInicial.comisionApertura', stepKey)} render={({ field }) => (
                        <InputNumber
                            inputId={field.name}
                            name={field.name}
                            value={field.value}
                            onValueChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            mode="currency"
                            currency="MXN"
                            locale="es-MX"
                            className="w-full"
                            minFractionDigits={2}
                            maxFractionDigits={2}
                        />
                    )} />
                    {errors.pagoInicial?.comisionApertura && <small className="p-error">{errors.pagoInicial.comisionApertura.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Gastos varios {isFieldRequired('pagoInicial.recuperacionGastos', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="pagoInicial.recuperacionGastos" control={control} rules={getValidationRules('pagoInicial.recuperacionGastos', stepKey)} render={({ field }) => (
                        <InputNumber
                            inputId={field.name}
                            name={field.name}
                            value={field.value}
                            onValueChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            mode="currency"
                            currency="MXN"
                            locale="es-MX"
                            className="w-full"
                            minFractionDigits={2}
                            maxFractionDigits={2}
                        />
                    )} />
                    {errors.pagoInicial?.recuperacionGastos && <small className="p-error">{errors.pagoInicial.recuperacionGastos.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Depósito en Garantía {isFieldRequired('pagoInicial.depositoGarantia', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="pagoInicial.depositoGarantia" control={control} rules={getValidationRules('pagoInicial.depositoGarantia', stepKey)} render={({ field }) => (
                        <InputNumber
                            inputId={field.name}
                            name={field.name}
                            value={field.value}
                            onValueChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            mode="currency"
                            currency="MXN"
                            locale="es-MX"
                            className="w-full"
                            minFractionDigits={2}
                            maxFractionDigits={2}
                        />
                    )} />
                    {errors.pagoInicial?.depositoGarantia && <small className="p-error">{errors.pagoInicial.depositoGarantia.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Total, pago inicial s/IVA {isFieldRequired('pagoInicial.totalSinIva', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="pagoInicial.totalSinIva" control={control} rules={getValidationRules('pagoInicial.totalSinIva', stepKey)} render={({ field }) => (
                        <InputNumber
                            inputId={field.name}
                            name={field.name}
                            value={field.value}
                            onValueChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            mode="currency"
                            currency="MXN"
                            locale="es-MX"
                            className="w-full"
                            minFractionDigits={2}
                            maxFractionDigits={2}
                        />
                    )} />
                    {errors.pagoInicial?.totalSinIva && <small className="p-error">{errors.pagoInicial.totalSinIva.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>IVA {isFieldRequired('pagoInicial.iva', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="pagoInicial.iva" control={control} rules={getValidationRules('pagoInicial.iva', stepKey)} render={({ field }) => (
                        <InputNumber
                            inputId={field.name}
                            name={field.name}
                            value={field.value}
                            onValueChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            mode="currency"
                            currency="MXN"
                            locale="es-MX"
                            className="w-full"
                            minFractionDigits={2}
                            maxFractionDigits={2}
                        />
                    )} />
                    {errors.pagoInicial?.iva && <small className="p-error">{errors.pagoInicial.iva.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Total pago inicial c/IVA {isFieldRequired('pagoInicial.totalConIva', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="pagoInicial.totalConIva" control={control} rules={getValidationRules('pagoInicial.totalConIva', stepKey)} render={({ field }) => (
                        <InputNumber
                            inputId={field.name}
                            name={field.name}
                            value={field.value}
                            onValueChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            mode="currency"
                            currency="MXN"
                            locale="es-MX"
                            className="w-full"
                            minFractionDigits={2}
                            maxFractionDigits={2}
                        />
                    )} />
                    {errors.pagoInicial?.totalConIva && <small className="p-error">{errors.pagoInicial.totalConIva.message}</small>}
                </div>
            </div>
        </div>
    );
}


